import { Button, Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import LoaderButton from '../button/loader-button';

interface ModalFooterProps {
  id: number;
  isLoading?: boolean;
  className?: string;
  saveNextBtn: 'save' | 'next' | 'update' | 'remove';
  backCancelBtn: 'back' | 'cancel';
  prev?: () => void;
  onModalClosed: () => void;
}

const ModalFooter = (props: ModalFooterProps) => {
  return (
    <Modal.Footer>
      <div className="d-flex justify-content-center ">
        <div className="row tab-action g-0">
          <div className="col-12">
            <Button
              variant="light-danger"
              type="button"
              onClick={
                props.backCancelBtn === 'back'
                  ? props.prev
                  : props.onModalClosed
              }
              disabled={props.isLoading}
            >
              <FormattedMessage id={props.backCancelBtn} />
            </Button>
            <LoaderButton
              type="submit"
              isLoading={props.isLoading}
              text={props.saveNextBtn}
            />
          </div>
        </div>
      </div>
    </Modal.Footer>
  );
};

export default ModalFooter;
